var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgBoostedEmployeeEng(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "1em",
    height: "1em",
    viewBox: "0 0 73.814 54.202",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_21044",
    "data-name": "Group 21044",
    transform: "translate(-0.75 -6.849)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_1047",
    "data-name": "Ellipse 1047",
    cx: 7.601,
    cy: 7.601,
    r: 7.601,
    transform: "translate(30.055 26.359)",
    fill: "#96006b"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_16082",
    "data-name": "Group 16082",
    transform: "translate(1.25 7.426)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_28416",
    "data-name": "Path 28416",
    d: "M31.608,15.841c-1.158-.958-2.759.833-1.532,1.85a14.794,14.794,0,0,1,0,22.763c-1.138.942.3,2.865,1.531,1.851a17.2,17.2,0,0,0,0-26.464Z",
    transform: "translate(15.788 -2.539)",
    fill: "#ff0185",
    stroke: "#ff0185",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_28417",
    "data-name": "Path 28417",
    d: "M36.107,11.8c-1.09-1-2.806.68-1.625,1.766a24.409,24.409,0,0,1,0,35.9c-1.106,1.019.489,2.817,1.624,1.767a26.808,26.808,0,0,0,0-39.435Z",
    transform: "translate(18.461 -4.984)",
    fill: "#ff0185",
    stroke: "#ff0185",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_28418",
    "data-name": "Path 28418",
    d: "M40.555,7.76c-1.092-1.049-2.81.629-1.663,1.732a33.976,33.976,0,0,1,0,48.935c-1.1,1.055.6,2.75,1.663,1.731a36.377,36.377,0,0,0,0-52.4Z",
    transform: "translate(21.119 -7.425)",
    fill: "#ff0185",
    stroke: "#ff0185",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_28419",
    "data-name": "Path 28419",
    d: "M15.65,29.075a14.724,14.724,0,0,1,5.342-11.382,1.2,1.2,0,0,0-1.532-1.85,17.2,17.2,0,0,0,0,26.463,1.2,1.2,0,0,0,1.533-1.849A14.724,14.724,0,0,1,15.65,29.075Z",
    transform: "translate(5.954 -2.541)",
    fill: "#ff0185",
    stroke: "#ff0185",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_28420",
    "data-name": "Path 28420",
    d: "M9.65,31.517a24.47,24.47,0,0,1,7.87-17.951c1.1-1.017-.523-2.779-1.626-1.767a26.81,26.81,0,0,0,0,39.435c1.1,1.017,2.805-.682,1.627-1.766A24.47,24.47,0,0,1,9.65,31.517Z",
    transform: "translate(2.352 -4.983)",
    fill: "#ff0185",
    stroke: "#ff0185",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_28421",
    "data-name": "Path 28421",
    d: "M3.65,33.96a33.645,33.645,0,0,1,10.4-24.466c1.079-1.038-.546-2.81-1.664-1.732a36.381,36.381,0,0,0,0,52.4c1.037,1,2.83-.61,1.665-1.731A33.645,33.645,0,0,1,3.65,33.96Z",
    transform: "translate(-1.25 -7.426)",
    fill: "#ff0185",
    stroke: "#ff0185",
    strokeWidth: 1
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBoostedEmployeeEng);
export default __webpack_public_path__ + "static/media/boosted-employee-eng.55e7a9408bbaf7b0301a4a24746144ba.svg";
export { ForwardRef as ReactComponent };